module.exports = __webpack_public_path__ + "img/enstsc_title.d11b0d2a.png";